<mat-toolbar>
  <div fxLayout="row" fxLayoutAlign="center center" fxLayoutAlign.gt-xs="space-between center" fxFlex>

    <a #submitFeedbackButton mat-button class="primary" fxFlex="0 0 auto" fxLayout="row" fxLayoutAlign="center center" (click)="openFeedbackDialog()">
      <mat-icon class="s-16 mr-sm-4">email</mat-icon>
      <span>Submit Feedback</span>
    </a>

    <div fxLayout="row" fxLayoutAlign="start center" fxHide fxShow.gt-xs>
      <a mat-button routerLink="/pages/documentation/changelog">Changelog</a>
    </div>
  </div>
</mat-toolbar>
